import { Outlet } from "react-router-dom";
import Header from "../../components/common/Header.jsx";
import Footer from "../../components/common/Footer.jsx";

const UserLayout = () => {
  return (
    <>
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer vendor={true} />
    </>
  );
};

export default UserLayout;
